export default "__VITE_ASSET__Bo3qaXKx__"